export const PLATFORM_INITIALISING = "PLATFORM_INITIALISING";
export const PLATFORM_IDLE = "PLATFORM_IDLE";

export const QUEUE_RUN = "QUEUE_RUN";
